import React from 'react';

function ItemsPerPage({ setEpisodesPerPage }) {
  return (
    <form
      className='select-container'
      onSubmit={(e) => {
        e.preventDefault();
      }}>
      <label htmlFor='number-of-items'>Number of results shown:</label>
      <select
        onChange={(e) => setEpisodesPerPage(e.target.value)}
        name='number-of-items'
        id='items'>
        <option value='10'>10</option>
        <option value='20'>20</option>
        <option value='50'>50</option>
        <option value='100'>100</option>
        <option value='200'>200</option>
      </select>
    </form>
  );
}

export default ItemsPerPage;
